import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

interface Props {
  data?: {
    month: string;
    totalVerifiedConversations: number;
  }[];
}

const MonthWiseGraph = ({ data = [] }: Props) => {
  const allMonths = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const monthMap: Record<string, number> = {};

  data.forEach((item) => {
    if (item?.month) {
      monthMap[item.month] = item.totalVerifiedConversations ?? 0;
    }
  });

  const labels = allMonths;
  const values = allMonths.map((month) => monthMap[month] || 0);


  const chartData = {
    labels,
    datasets: [
      {
        label: "User Conversions",
        data: values,
        backgroundColor: "rgba(54, 162, 235, 0.6)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: "top" as const,
      },
      tooltip: {
        callbacks: {
          label: (context: any) => `Conversions: ${context.parsed.y}`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Total Verified Conversions",
        },
      },
      x: {
        title: {
          display: true,
          text: "Months",
        },
      },
    },
  };

  return <Bar data={chartData} options={options} />;
};

export default MonthWiseGraph;
